import React from 'react';
import { BaseTimePeriod } from '@services/FiltersTypes';

import * as styles from './PeriodDisplay.module.scss';

export type PeriodDisplayProps = {
  earliestPeriod: BaseTimePeriod;
  latestPeriod: BaseTimePeriod;
};

const PeriodDisplay: React.FC<PeriodDisplayProps> = ({ earliestPeriod, latestPeriod }) => {
  return (
    <span className={styles.PeriodDisplay}>
      {latestPeriod.label}
      <span className={styles.PeriodDisplay__versus}>vs</span>
      {earliestPeriod.label}
    </span>
  );
};

export default PeriodDisplay;
